<app-navbar-loggin></app-navbar-loggin>
<app-forms-confirm-registration></app-forms-confirm-registration>
<app-footer></app-footer>
